var _path, _path2, _polygon, _polygon2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsultingRafiki(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-43"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.41,
    y: 71.37,
    width: 71.25,
    height: 241.71,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.39,
    y: 156.93,
    width: 89.08,
    height: 154.04,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.5 135.41 385.5 174.04 392.53 174.04 433.34 174.04 440.37 174.04 440.37 135.41 385.5 135.41",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.1,
    y: 162.64,
    width: 11.4,
    height: 11.4,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.19,
    y: 162.64,
    width: 11.4,
    height: 11.4,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.28,
    y: 162.64,
    width: 11.4,
    height: 11.4,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.37,
    y: 162.64,
    width: 11.41,
    height: 11.4,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.1,
    y: 183.36,
    width: 11.4,
    height: 11.41,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.19,
    y: 183.36,
    width: 11.4,
    height: 11.41,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.28,
    y: 183.36,
    width: 11.4,
    height: 11.41,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.37,
    y: 183.36,
    width: 11.41,
    height: 11.41,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.1,
    y: 204.08,
    width: 11.4,
    height: 11.4,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.19,
    y: 204.08,
    width: 11.4,
    height: 11.4,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.28,
    y: 204.08,
    width: 11.4,
    height: 11.4,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.19,
    y: 144.72,
    width: 11.4,
    height: 11.4,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.28,
    y: 144.72,
    width: 11.4,
    height: 11.4,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.37,
    y: 204.08,
    width: 11.41,
    height: 11.4,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.1,
    y: 224.8,
    width: 11.4,
    height: 11.4,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.19,
    y: 224.8,
    width: 11.4,
    height: 11.4,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.28,
    y: 224.8,
    width: 11.4,
    height: 11.4,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.37,
    y: 224.8,
    width: 11.41,
    height: 11.4,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.1,
    y: 245.53,
    width: 11.4,
    height: 11.41,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.19,
    y: 245.53,
    width: 11.4,
    height: 11.41,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.28,
    y: 245.53,
    width: 11.4,
    height: 11.41,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.37,
    y: 245.53,
    width: 11.41,
    height: 11.41,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.1,
    y: 266.25,
    width: 11.4,
    height: 11.4,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.19,
    y: 266.25,
    width: 11.4,
    height: 11.4,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.28,
    y: 266.25,
    width: 11.4,
    height: 11.4,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.37,
    y: 266.25,
    width: 11.41,
    height: 11.4,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.1,
    y: 286.97,
    width: 11.4,
    height: 11.41,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.19,
    y: 286.97,
    width: 11.4,
    height: 11.41,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.28,
    y: 286.97,
    width: 11.4,
    height: 11.41,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.37,
    y: 286.97,
    width: 11.41,
    height: 11.41,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.27,
    y: 71.37,
    width: 71.25,
    height: 241.71,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "448.55 71.37 425.83 71.37 400.98 313.08 423.69 313.08 448.55 71.37",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 383.81,
    y: 68.31,
    width: 72.45,
    height: 6.13,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.81,
    y: 310.97,
    width: 72.45,
    height: 6.13,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.07,322.33H380.53v-260h78.54Zm-72.55-6h66.57v-248H386.52Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.69,
    y: 71.37,
    width: 71.25,
    height: 241.71,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.62,
    y: 237.04,
    width: 60.93,
    height: 74.77,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.25 245.33 353.07 245.33 349.17 245.33 345.27 245.33 345.27 253.13 349.17 253.13 353.07 253.13 367.25 253.13 367.25 245.33",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.25 260.44 353.07 260.44 349.17 260.44 345.27 260.44 345.27 268.24 349.17 268.24 353.07 268.24 367.25 268.24 367.25 260.44",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.25 275.55 353.07 275.55 349.17 275.55 345.27 275.55 345.27 283.35 349.17 283.35 353.07 283.35 367.25 283.35 367.25 275.55",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.25 290.66 353.07 290.66 347.05 290.66 345.27 290.66 345.27 298.46 347.05 298.46 353.07 298.46 367.25 298.46 367.25 290.66",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.9 245.33 324.73 245.33 320.83 245.33 316.93 245.33 316.93 253.13 320.83 253.13 324.73 253.13 338.9 253.13 338.9 245.33",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.9 260.44 324.73 260.44 319.23 260.44 316.93 260.44 316.93 268.24 319.23 268.24 324.73 268.24 338.9 268.24 338.9 260.44",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.9 275.55 324.73 275.55 320.83 275.55 316.93 275.55 316.93 283.35 320.83 283.35 324.73 283.35 338.9 283.35 338.9 275.55",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.9 290.66 324.73 290.66 320.83 290.66 316.93 290.66 316.93 298.46 320.83 298.46 324.73 298.46 338.9 298.46 338.9 290.66",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.46,
    y: 71.37,
    width: 71.25,
    height: 241.71,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "370.83 71.37 348.12 71.37 323.26 313.08 345.98 313.08 370.83 71.37",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 306.09,
    y: 68.31,
    width: 72.45,
    height: 6.13,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.09,
    y: 310.97,
    width: 72.45,
    height: 6.13,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.36,322.33H302.82v-260h78.54Zm-72.56-6h66.57v-248H308.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 71.37,
    width: 71.25,
    height: 241.71,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.86,
    y: 71.37,
    width: 71.25,
    height: 241.71,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "184.15 71.37 161.43 71.37 136.58 313.08 159.29 313.08 184.15 71.37",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 119.41,
    y: 68.31,
    width: 72.45,
    height: 6.13,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.41,
    y: 310.97,
    width: 72.45,
    height: 6.13,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.67,322.33H116.13v-260h78.54Zm-72.55-6h66.56v-248H122.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.39,
    y: 71.37,
    width: 71.25,
    height: 241.71,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.75,
    y: 173.73,
    width: 55.15,
    height: 46.28,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.28,
    y: 179.5,
    width: 7.06,
    height: 7.06,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.96,
    y: 179.5,
    width: 7.06,
    height: 7.06,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.64,
    y: 179.5,
    width: 7.06,
    height: 7.06,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.31,
    y: 179.5,
    width: 7.06,
    height: 7.06,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.28,
    y: 192.33,
    width: 7.06,
    height: 7.06,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.96,
    y: 192.33,
    width: 7.06,
    height: 7.06,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.64,
    y: 192.33,
    width: 7.06,
    height: 7.06,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.31,
    y: 192.33,
    width: 7.06,
    height: 7.06,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.28,
    y: 205.15,
    width: 7.06,
    height: 7.06,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.96,
    y: 205.15,
    width: 7.06,
    height: 7.06,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.64,
    y: 205.15,
    width: 7.06,
    height: 7.06,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.31,
    y: 205.15,
    width: 7.06,
    height: 7.06,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.75,
    y: 219.43,
    width: 55.15,
    height: 46.28,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.28,
    y: 225.19,
    width: 7.06,
    height: 7.06,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.96,
    y: 225.19,
    width: 7.06,
    height: 7.06,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.64,
    y: 225.19,
    width: 7.06,
    height: 7.06,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.31,
    y: 225.19,
    width: 7.06,
    height: 7.06,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.28,
    y: 238.02,
    width: 7.06,
    height: 7.06,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.96,
    y: 238.02,
    width: 7.06,
    height: 7.06,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.64,
    y: 238.02,
    width: 7.06,
    height: 7.06,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.31,
    y: 238.02,
    width: 7.06,
    height: 7.06,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.28,
    y: 250.85,
    width: 7.06,
    height: 7.06,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.96,
    y: 250.85,
    width: 7.06,
    height: 7.06,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.64,
    y: 250.85,
    width: 7.06,
    height: 7.06,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.31,
    y: 250.85,
    width: 7.06,
    height: 7.06,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.75,
    y: 265.12,
    width: 55.15,
    height: 46.28,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.28,
    y: 270.89,
    width: 7.06,
    height: 7.06,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.96,
    y: 270.89,
    width: 7.06,
    height: 7.06,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.64,
    y: 270.89,
    width: 7.06,
    height: 7.06,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.31,
    y: 270.89,
    width: 7.06,
    height: 7.06,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.28,
    y: 283.72,
    width: 7.06,
    height: 7.06,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.96,
    y: 283.72,
    width: 7.06,
    height: 7.06,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.64,
    y: 283.72,
    width: 7.06,
    height: 7.06,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.31,
    y: 283.72,
    width: 7.06,
    height: 7.06,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.28,
    y: 296.55,
    width: 7.06,
    height: 7.06,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.96,
    y: 296.55,
    width: 7.06,
    height: 7.06,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.64,
    y: 296.55,
    width: 7.06,
    height: 7.06,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.31,
    y: 296.55,
    width: 7.06,
    height: 7.06,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.45,
    y: 71.37,
    width: 71.25,
    height: 241.71,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "106.53 71.37 83.82 71.37 58.97 313.08 81.68 313.08 106.53 71.37",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 41.8,
    y: 68.31,
    width: 72.45,
    height: 6.13,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.8,
    y: 310.97,
    width: 72.45,
    height: 6.13,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.06,322.33H38.52v-260h78.54Zm-72.55-6h66.56v-248H44.51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.52,354.61l-.8.1c-.05-.41-4.91-41.09,5.12-74.33,10-33,3.1-54.1,3-54.3l.77-.26c.07.21,7,21.51-3,54.79C238.63,313.69,243.47,354.21,243.52,354.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.3,230.61a12.64,12.64,0,0,0-6.76-4.17l.19-.79a13.43,13.43,0,0,1,7.19,4.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.45,
    y: 234.58,
    width: 2.65,
    height: 0.81,
    transform: "translate(-82.64 155.74) rotate(-29.47)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.43,252.73a19.19,19.19,0,0,0-10.38-10.08l.3-.74a20,20,0,0,1,10.82,10.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.27,278.14h-.81a11.08,11.08,0,0,0-4.18-8.49l.5-.63A11.91,11.91,0,0,1,249.27,278.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.47,284.64l-.76-.29a8.12,8.12,0,0,1,4.6-4.54l.28.76A7.24,7.24,0,0,0,247.47,284.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.23,325.87l-.62-.51c1-1.19,1.73-5.7,2.13-8.12.09-.58.17-1.07.24-1.43l.79.15c-.06.35-.14.84-.24,1.41C243.94,321,243.27,324.62,242.23,325.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.77,338.82a8,8,0,0,0-7.71-5.32l0-.81a8.81,8.81,0,0,1,8.52,5.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.13,
    y: 350.3,
    width: 8.54,
    height: 0.81,
    transform: "translate(-179.62 299.99) rotate(-48.21)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,305.75c1.29,4.17-7.7,12.12-7.7,12.12s-11.91-1.49-13.2-5.67,1.73-11,7.5-12.78S250.67,301.58,252,305.75Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.94,255.11c-1.14,4.43-9.66,7.58-9.66,7.58s-5.94-6.87-4.8-11.3,5.85-9.32,9.84-8.29S263.08,250.68,261.94,255.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.77,321.33c5.34,2.09,8.62,11.54,8.62,11.54s-8.81,4.75-14.16,2.67-11-8-9.48-11.87S222.42,319.25,227.77,321.33Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.49,269.3a11.44,11.44,0,0,0,3.65,2.07,3.89,3.89,0,0,0,3.9-.92c1.15-1.32.84-3.36.12-4.95-1.43-3.15-6.7-8.49-10.75-7C230.57,260.75,236.88,267.37,239.49,269.3Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.45,277.33c-.77.95-1.58,2.14-1.16,3.29a2.44,2.44,0,0,0,2.69,1.32,7.22,7.22,0,0,0,2.89-1.41c2.06-1.44,6.29-4.44,3.59-7.25S253.06,275.32,251.45,277.33Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.19,237.33a2.12,2.12,0,0,0-1.93,1.56c-.17,1,.68,1.92,1.5,2.55,2.05,1.58,8.2,5.84,9.58,1.73C244.64,239.29,236.91,237,234.19,237.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.54,223.81c-1.27.12-2.54-.34-3.81-.26s-2.69,1.1-2.4,2.35,1.69,1.53,2.86,1.61a23.3,23.3,0,0,0,6-.42,1.84,1.84,0,0,0,1.21-.61c.52-.76-.3-1.78-1.18-2a13.06,13.06,0,0,1-2.66-.63Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,232.55c1.28,0,2.51-.51,3.79-.51s2.75.92,2.55,2.18-1.59,1.65-2.76,1.8a22.82,22.82,0,0,1-6,0,1.86,1.86,0,0,1-1.26-.53c-.56-.73.19-1.79,1-2.12a12.66,12.66,0,0,0,2.62-.81Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.69,326.51a1.8,1.8,0,0,1,1.09-.54,1.23,1.23,0,0,1,1.08,1.06,3.55,3.55,0,0,1-.2,1.61c-.87,2.89-10.57,23.84-12.81,20.08-1.32-2.23,1.93-9.59,2.89-11.68A30.37,30.37,0,0,1,256.69,326.51Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.89,224.6A11,11,0,0,1,254,220c1.53-1.11,4-1.19,5.1.34,1.25,1.71,0,4.31-1.91,5.22s-4.14.63-6.24.34c0-.31,0-.62-.05-.93Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.67,382.55h0a93.5,93.5,0,0,1-31.4,0h0l-12.21-36h55.83Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250.59,
    cy: 92.25,
    r: 20.73,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 249.19,
    cy: 91.38,
    r: 20.73,
    transform: "translate(119.08 322.72) rotate(-80.78)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.83,91.52a16.64,16.64,0,1,1-16.64-16.64A16.64,16.64,0,0,1,265.83,91.52Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.29,93.09a1.69,1.69,0,0,1,2.39-2.39,1.69,1.69,0,1,1-2.39,2.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.19 91.32 259.01 91.02 259.04 92.04 250.14 92.31 249.18 107.79 248.17 107.73 249.19 91.32",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-43"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-43",
    cx: 250,
    cy: 415.69,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.35,362.91l5.08-80.86a52.16,52.16,0,0,0-52.06-55.43h0a52.16,52.16,0,0,0-52.07,49.22L326,370.28H422.5A7.87,7.87,0,0,0,430.35,362.91Z",
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.53,360l4.9-77.93a52.16,52.16,0,0,0-52.06-55.43h0a52.16,52.16,0,0,0-52.07,49.22L326,370.28h93.59A11,11,0,0,0,430.53,360Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.69,370.28l5.54-88.23a52.17,52.17,0,0,0-52.06-55.43h0a52.15,52.15,0,0,0-52.07,49.22l-5.33,94.44Z",
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.35,385.47h1.33a1.51,1.51,0,0,0,1.42-1.35l2-13.83H413l2,13.83A1.52,1.52,0,0,0,416.35,385.47Z",
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.35,385.47h1.33a1.51,1.51,0,0,0,1.42-1.35l2-13.83H413l2,13.83A1.52,1.52,0,0,0,416.35,385.47Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.7,385.47h1.2a1.44,1.44,0,0,0,1.29-1.35L290,370.29h-7.36l1.79,13.83A1.44,1.44,0,0,0,285.7,385.47Z",
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.7,385.47h1.2a1.44,1.44,0,0,0,1.29-1.35L290,370.29h-7.36l1.79,13.83A1.44,1.44,0,0,0,285.7,385.47Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.31,385.47h1.21a1.44,1.44,0,0,0,1.29-1.35l1.78-13.83h-7.35L322,384.12A1.44,1.44,0,0,0,323.31,385.47Z",
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.31,385.47h1.21a1.44,1.44,0,0,0,1.29-1.35l1.78-13.83h-7.35L322,384.12A1.44,1.44,0,0,0,323.31,385.47Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.85,385.47h1.33a1.53,1.53,0,0,0,1.43-1.35l2-13.83h-8.11l2,13.83A1.51,1.51,0,0,0,375.85,385.47Z",
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.85,385.47h1.33a1.53,1.53,0,0,0,1.43-1.35l2-13.83h-8.11l2,13.83A1.51,1.51,0,0,0,375.85,385.47Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.82,337H296.26l-2.35-34.28-.51-7.36h0l-.23-3.39a22.55,22.55,0,0,0-.35-2.65c0-.19-.08-.4-.12-.59a2,2,0,0,0-.11-.42,20.51,20.51,0,0,0-5.41-9.21,17.46,17.46,0,0,0-11.11-5h33.45c.36,0,.73,0,1.1,0a17.35,17.35,0,0,1,12.11,5,20.53,20.53,0,0,1,5.42,9.21,2,2,0,0,1,.11.42,22.57,22.57,0,0,1,.47,3.24l.23,3.39h0Z",
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.82,337H296.26l-2.35-34.28-.51-7.36h0l-.23-3.39a22.55,22.55,0,0,0-.35-2.65c0-.19-.08-.4-.12-.59a2,2,0,0,0-.11-.42,20.51,20.51,0,0,0-5.41-9.21,17.46,17.46,0,0,0-11.11-5h33.45c.36,0,.73,0,1.1,0a17.35,17.35,0,0,1,12.11,5,20.53,20.53,0,0,1,5.42,9.21,2,2,0,0,1,.11.42,22.57,22.57,0,0,1,.47,3.24l.23,3.39h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M360,318.7h14.28c3.48,0,6.29,2.2,6.29,4.91v8.44c0,2.72-2.81,4.91-6.29,4.91H360Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 296.26,
    y: 318.7,
    width: 73.74,
    height: 18.27,
    rx: 5.42,
    transform: "translate(666.27 655.66) rotate(180)",
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450,294.27a20.26,20.26,0,0,1-16.81,20L429.54,363c-.32,4.14-3.33,7.31-6.93,7.31H383.39c3.6,0,6.6-3.17,6.92-7.31l2-26L394,314.24a20.18,20.18,0,0,0,14.53-10.66,11,11,0,0,0,.53-1.09,20,20,0,0,0,1.74-8.22,20.81,20.81,0,0,0-.42-4.13c-.11-.54-.25-1.08-.4-1.61a20.55,20.55,0,0,0-3.36-6.59h0A20.31,20.31,0,0,0,390.55,274h39.22a19.9,19.9,0,0,1,9.05,2.14,20.11,20.11,0,0,1,7,5.77h0A20.21,20.21,0,0,1,450,294.27Z",
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450,294.27a20.26,20.26,0,0,1-16.81,20L429.54,363c-.32,4.14-3.33,7.31-6.93,7.31H383.39c3.6,0,6.6-3.17,6.92-7.31l2-26L394,314.24a20.18,20.18,0,0,0,14.53-10.66,11,11,0,0,0,.53-1.09,20,20,0,0,0,1.74-8.22,20.81,20.81,0,0,0-.42-4.13c-.11-.54-.25-1.08-.4-1.61a20.55,20.55,0,0,0-3.36-6.59h0A20.31,20.31,0,0,0,390.55,274h39.22a19.9,19.9,0,0,1,9.05,2.14,20.11,20.11,0,0,1,7,5.77h0A20.21,20.21,0,0,1,450,294.27Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.81,294.28c0,10-6.59,18.33-15.24,20L392.23,363c-.29,4.14-3,7.32-6.28,7.32H281.21c-3.26,0-6-3.18-6.28-7.32l-3.35-48.81c-8.48-1.78-14.89-10-14.89-19.88a21.56,21.56,0,0,1,3.39-11.71,19,19,0,0,1,6.77-6.41,16.75,16.75,0,0,1,8.21-2.15,17.44,17.44,0,0,1,12.12,5,20.48,20.48,0,0,1,5.41,9.2,2.18,2.18,0,0,1,.11.44,22,22,0,0,1,.47,3.23l.24,3.39h0L296.26,337H370.9l3.09-45c.44-6.36,3.54-11.66,7.84-14.17a17,17,0,0,1,9.51-3.69,10,10,0,0,1,1.1-.05,16.63,16.63,0,0,1,8,2,1.55,1.55,0,0,1,.22.12,18.84,18.84,0,0,1,6.36,5.77h0A21.63,21.63,0,0,1,410.81,294.28Z",
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.17,370.29h-88c-3.26,0-6-3.18-6.28-7.32l-3.35-48.81c-8.48-1.78-14.89-10-14.89-19.88a21.56,21.56,0,0,1,3.39-11.71,19,19,0,0,1,6.77-6.41,16.75,16.75,0,0,1,8.21-2.15,17.44,17.44,0,0,1,12.12,5,20.48,20.48,0,0,1,5.41,9.2,2.18,2.18,0,0,1,.11.44,22,22,0,0,1,.47,3.23l.24,3.39h0L296.26,337H370.9Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.76,231.72c-1.74,1-3.33,1.83-5,2.68s-3.31,1.63-5,2.41c-3.36,1.53-6.76,3-10.26,4.27a112.83,112.83,0,0,1-10.76,3.4,68.84,68.84,0,0,1-11.56,2.07l-.83.08-.39,0c-3.53-.41-6.66-1-9.8-1.7s-6.25-1.39-9.33-2.18-6.14-1.6-9.2-2.48-6.09-1.79-9.12-2.82l1.39-6.94c6.29.4,12.57,1,18.79,1.65l9.29.93c3.06.3,6.19.56,8.93.66l-1.21,0a67.13,67.13,0,0,0,9.26-2.34c3.13-1,6.26-2.14,9.39-3.48s6.23-2.72,9.31-4.19c1.58-.72,3.11-1.48,4.61-2.23s3.1-1.55,4.47-2.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.76,231.72c-1.74,1-3.33,1.83-5,2.68s-3.31,1.63-5,2.41c-3.36,1.53-6.76,3-10.26,4.27a112.83,112.83,0,0,1-10.76,3.4,68.84,68.84,0,0,1-11.56,2.07l-.83.08-.39,0c-3.53-.41-6.66-1-9.8-1.7s-6.25-1.39-9.33-2.18-6.14-1.6-9.2-2.48-6.09-1.79-9.12-2.82l1.39-6.94c6.29.4,12.57,1,18.79,1.65l9.29.93c3.06.3,6.19.56,8.93.66l-1.21,0a67.13,67.13,0,0,0,9.26-2.34c3.13-1,6.26-2.14,9.39-3.48s6.23-2.72,9.31-4.19c1.58-.72,3.11-1.48,4.61-2.23s3.1-1.55,4.47-2.26Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.63,226.7a17.09,17.09,0,0,0-4.84-2.36l-2.59,10.11,7.76,3.26.88-1.08A6.89,6.89,0,0,0,276.63,226.7Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.2 234.45 271.79 224.34 264.55 220.39 262.37 227.51 269.2 234.45",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.41,242h.28l.12,0c3.82-.41,15.05-2.3,23.17-10.31-1.21-2.34-2.87-4.15-4.9-4.56C346.48,226.07,339.62,230.08,333.41,242Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,294.27c9.58-25.87,3.28-49.66,4.48-62.83a15,15,0,0,1,12.14-13.38c6.54-1.26,14.63-2.68,22.34-3.72a15.08,15.08,0,0,1,17.14,15.18c-.67,39-13.17,64.75-13.17,64.75l-20.2-.09Z",
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,294.27c9.58-25.87,3.28-49.66,4.48-62.83a15,15,0,0,1,12.14-13.38c6.54-1.26,14.63-2.68,22.34-3.72a15.08,15.08,0,0,1,17.14,15.18c-.67,39-13.17,64.75-13.17,64.75l-20.2-.09Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-102--inject-43"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "263.36 382.54 260.8 399.37 268.93 399.37 274.27 382.54 263.36 382.54",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.76,395.62l10.87-.26a.61.61,0,0,1,.68.6l0,8a1.83,1.83,0,0,1-1.79,1.63c-3.78,0-5.58-.14-10.36,0a122.2,122.2,0,0,1-15.22-1c-3.87-.66-2.82-4.29-1.07-4.35,7.9-.29,12.32-1.94,15.16-4A2.92,2.92,0,0,1,259.76,395.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.33 389.29 263.36 382.54 274.27 382.54 271.65 390.96 262.33 389.29",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,288.21s-66.15.66-67.18,21.61c-1.46,30.12-6.55,76-6.55,76l12.47,3.43s17.8-45.53,18.49-69.06c18.61-3.7,66.44,0,72.06-12.22a32.72,32.72,0,0,0,2.12-19.8Z",
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,288.21s-66.15.66-67.18,21.61c-1.46,30.12-6.55,76-6.55,76l12.47,3.43s17.8-45.53,18.49-69.06c18.61-3.7,66.44,0,72.06-12.22a32.72,32.72,0,0,0,2.12-19.8Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.56 389.05 325.97 400.47 334.89 400.47 331.82 388.46 321.56 389.05",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.65 391.7 330.92 382.91 319.65 384.31 322.54 391.95 332.65 391.7",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.55,396.69h11.39a.7.7,0,0,1,.75.64h0l.55,8.53a1.76,1.76,0,0,1-1.77,1.72c-4-.07-5.86-.29-10.87-.29-3.07,0-9.29.3-13.54.3s-4.13-4-2.34-4.31c8.1-1.62,11.23-3.85,14.08-6A3,3,0,0,1,323.55,396.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.79,288.21s-60,4.07-58.52,25c1.61,22.92,25.64,76.07,25.64,76.07H332S324,341.06,320.32,317.7c16.92,0,56.13,2.55,61.77-9.7a32.79,32.79,0,0,0,2.1-19.8Z",
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.79,288.21s-60,4.07-58.52,25c1.61,22.92,25.64,76.07,25.64,76.07H332S324,341.06,320.32,317.7c16.92,0,56.13,2.55,61.77-9.7a32.79,32.79,0,0,0,2.1-19.8Z",
    style: {
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M361.88,203.42c1.38,5.34,1.81,12-5.65,14.75-2.07,3.3-3.08,6.78,4.89,5.54a24.54,24.54,0,0,0,16.09-9.1c-4.77-4.18-3.9-17-2.69-24.23Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,213.14c-6.85,1.17-12.48,6.47-15.5,12.72s-3.75,13.37-3.69,20.32.85,13.87.66,20.81c-.21,8-2.14,13.67-4.9,21.21,0,1.79,2.71,2.8,5,3.27,4.78-10.43,7.92-20.41,7.59-31.87-.25-8.32-.36-17.8,1-26s11.17-18.91,10.7-20.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.7,207.34a6.65,6.65,0,0,1-5.06,1.22,23,23,0,0,0-.28-3.88l8.28-6.8a18.73,18.73,0,0,1,.35,2.68A7.59,7.59,0,0,1,367.7,207.34Z",
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.32,171.84c-8.75,4.95-8.84,18.94-6.14,27a12.12,12.12,0,0,0,21.23,3.56c4.28-5.41,3.66-10.87,3.45-20.27S364.08,166.9,355.32,171.84Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.14,197c-2.82,1.21-5.91,2.78-8.76,2.44a12.11,12.11,0,0,0,21,3C373.91,198,375,195,374,186.92,368.52,193.34,364.17,194.4,358.14,197Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.6,175a8,8,0,0,0,.89,9.57c.79.83,1.76,1.47,2.52,2.32a6.84,6.84,0,0,1,1.72,4.86,5,5,0,0,1,4.75-4.23q-1.78,5.51-3.56,11a15.22,15.22,0,0,0,8.68-12C382.36,179.42,373.6,164.21,366.6,175Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.18,175.49a6.13,6.13,0,0,0-1.39,2.61,2.42,2.42,0,0,0,1,2.58,3.65,3.65,0,0,0,2.38.12l8-1.39c4.58-.8,9.16-1.59,13.68-2.68,2-.48,4.31-1.25,5.11-3.17,2.59-6.25-8.47-7.06-12.17-6.89C356.49,167,350.12,170.62,346.18,175.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.28,185.92c-2.62.59-3.74,4.36-3.67,6.78,0,2.75,2,4.54,4.32,2.88a8.47,8.47,0,0,0,3.28-5.28C379.68,187.71,377.91,185.33,375.28,185.92Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.77,195.47a3.25,3.25,0,0,1-2.73.41c1-2.26.88-1.75,1.19-5.59Z",
    style: {
      fill: "#ed847e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.38,183c-.75-.84-2.8-1.16-3.91-1h0a.44.44,0,0,1-.49-.36.48.48,0,0,1,.38-.53c1.4-.21,3.73.21,4.68,1.26h0a.45.45,0,0,1,0,.63.53.53,0,0,1-.2.13A.44.44,0,0,1,361.38,183Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.44,184.87h0a.44.44,0,0,1-.12-.6,4.65,4.65,0,0,1,3.43-2.35h0a.41.41,0,0,1,.42.41.47.47,0,0,1-.43.49,3.77,3.77,0,0,0-2.7,1.89.45.45,0,0,1-.36.23A.35.35,0,0,1,348.44,184.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,199.54a37.77,37.77,0,0,1,2.65,3.84l.62-.26c2.82-1.22,3.62-2.92,3.66-4.43a6.42,6.42,0,0,0-1.07-3.37c-1,1.73-3.53,3.11-4.91,3.78C356.36,199.39,356,199.54,356,199.54Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.93,199.1l.41.56a.84.84,0,0,0,1,.27c2.08-1,3.46-2,4-3.13a.81.81,0,0,0,0-.68,6.32,6.32,0,0,0-.46-.8C360.83,197.05,358.31,198.43,356.93,199.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.25,203.12c2.82-1.22,3.62-2.92,3.66-4.43a8.19,8.19,0,0,0-2.79,2.11A4,4,0,0,0,359.25,203.12Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.65,188c-.49.09-.76.79-.62,1.54s.67,1.29,1.16,1.19.76-.78.62-1.53S352.14,188,351.65,188Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.23,186.62c-.49.09-.76.78-.62,1.54s.67,1.29,1.16,1.19.76-.79.62-1.54S360.72,186.53,360.23,186.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.87 192.06 354.18 190.64 354.29 193.32 348.42 194.72 347.87 192.06",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "356.1 190.22 356.85 192.68 364.95 190.94 364.47 188.1 356.1 190.22",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "354.22 191.63 354.18 190.64 356.1 190.22 356.38 191.15 354.22 191.63",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.92,293.12s11.39,4.41,14,5.27a32.69,32.69,0,0,0,9.37,2.15,11.5,11.5,0,0,0,8.87-3.31c2.72-2.9,3.57-7.3,4.28-11.43q3.12-18.19,6.26-36.38c1-6,3.63-15,3.41-18.39-.41-6.3-4.42-13.74-14.63-17.83-4-1.59-7.89-1-11.23,3-2,2.38-7.82,8.12-9.25,18.23-1.14,8.1-2.92,18.59-2.81,26.82C360.32,272.07,356,285.71,351.92,293.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.55,227.7c1.16,10.54-4.67,37.11-5.79,38.71-4.78,15.41-17.91,7.1-19.81,6.39-3.31-1.22-6.68-3.61-9.83-5.2-6.11-3-11.9-5.48-17.58-9.25l3.2-6.32c6.23,2.12,23.86,6.68,26.77,7.39,1.26.33,6.17,2.9,6.12-.49.69-1.13,1.65-23.14,3.76-30.92a6.56,6.56,0,0,1,1.23-2.39l.19-.24a6.74,6.74,0,0,1,11.74,2.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.55,227.7c1.16,10.54-4.67,37.11-5.79,38.71-4.78,15.41-17.91,7.1-19.81,6.39-3.31-1.22-6.68-3.61-9.83-5.2-6.11-3-11.9-5.48-17.58-9.25l3.2-6.32c6.23,2.12,23.86,6.68,26.77,7.39,1.26.33,6.17,2.9,6.12-.49.69-1.13,1.65-23.14,3.76-30.92a6.56,6.56,0,0,1,1.23-2.39l.19-.24a6.74,6.74,0,0,1,11.74,2.32Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.24 267.5 315.64 267.5 312.26 228.88 341.86 228.88 345.24 267.5",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.24 267.5 315.64 267.5 312.26 228.88 341.86 228.88 345.24 267.5",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.19 267.31 314.59 267.31 311.21 228.69 340.81 228.69 344.19 267.31",
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.19 267.31 314.59 267.31 311.21 228.69 340.81 228.69 344.19 267.31",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.45 231.1 320 231.1 319.58 226.27 332.02 226.27 332.45 231.1",
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.58 226.27 320.8 225.85 333.69 225.85 333.87 227.9 332.91 229.01 332.85 230.69 332.45 231.1 332.02 226.27 319.58 226.27",
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.58 226.27 320.8 225.85 333.69 225.85 333.87 227.9 332.91 229.01 332.85 230.69 332.45 231.1 332.02 226.27 319.58 226.27",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.1,254.12l.67,3.61c-1.6,4.17-10.77,3.07-10.77,3.07l0-10.67,8.09,1.88A2.7,2.7,0,0,1,350.1,254.12Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.98 250.13 340.02 260.82 331.9 261.02 330.04 251.62 339.98 250.13",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.9,337l3.09-45c.44-6.36,3.54-11.66,7.84-14.17a17,17,0,0,1,9.51-3.69,10,10,0,0,1,1.1-.05,16.63,16.63,0,0,1,8,2,1.55,1.55,0,0,1,.22.12,18.84,18.84,0,0,1,6.36,5.77h0a21.63,21.63,0,0,1,3.8,12.34c0,10-6.59,18.33-15.24,20L392.23,363c-.29,4.14-3,7.32-6.28,7.32H369.17Z",
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.9,337l3.09-45c.44-6.36,3.54-11.66,7.84-14.17a17,17,0,0,1,9.51-3.69,10,10,0,0,1,1.1-.05,16.63,16.63,0,0,1,8,2,1.55,1.55,0,0,1,.22.12,18.84,18.84,0,0,1,6.36,5.77h0a21.63,21.63,0,0,1,3.8,12.34c0,10-6.59,18.33-15.24,20L392.23,363c-.29,4.14-3,7.32-6.28,7.32H369.17Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--text-balloon--inject-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.3,127.6v41.81a4,4,0,0,1-4,4H171.48l-15.3,11.83a2.92,2.92,0,0,1-4.68-2.34v-9.49h-2.39a4,4,0,0,1-4-4V127.59a3.94,3.94,0,0,1,4-3.92h65.26A3.93,3.93,0,0,1,218.3,127.6Z",
    style: {
      fill: "none",
      stroke: "#3C008F",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.03,
    y: 117.78,
    width: 8.17,
    height: 1,
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,129.56h-1v-4.93a6.87,6.87,0,0,1,6.87-6.86h18.23v1H145.85a5.88,5.88,0,0,0-5.87,5.86Z",
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.77,154.3a3.15,3.15,0,0,1-3.16-3.38v0c1.07-12.19,10.73-13.31,11.94-27.17.35-4-1.11-5.5-3.9-5.5s-4.51,1.51-4.86,5.5l-.2,2.28a4.13,4.13,0,0,1-4.12,3.77h0a4.13,4.13,0,0,1-4.11-4.49l.09-1c.78-8.92,5.61-14,14.14-14s12.46,5.1,11.68,14C214,138.76,203.45,141,202.55,151.19a.76.76,0,0,1,0,.15,3.18,3.18,0,0,1-3.16,3Zm4.33,8.48v0a4.2,4.2,0,0,1-4.19,3.84h0a4.2,4.2,0,0,1-4.19-4.57v0a4.2,4.2,0,0,1,4.2-3.84h0A4.21,4.21,0,0,1,202.1,162.78Z",
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.5,144.51h-23a2,2,0,1,1,0-4h23a2,2,0,0,1,0,4Z",
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.32,152.43H163.54a2,2,0,0,1,0-4h19.78a2,2,0,0,1,0,4Z",
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.14,160.34h-16.6a2,2,0,0,1,0-4h16.6a2,2,0,0,1,0,4Z",
    style: {
      fill: "#3C008F"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.08,323.51H118.47c-3.56,0-6.44,2.25-6.44,5v8.64c0,2.78,2.88,5,6.44,5h14.61Z",
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.18,364.2,60.1,283.34a52.15,52.15,0,0,1,52.05-55.42h0a52.16,52.16,0,0,1,52.08,49.22l5.32,94.44H73A7.87,7.87,0,0,1,65.18,364.2Z",
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,361.27,60.1,283.34a52.15,52.15,0,0,1,52.05-55.42h0a52.16,52.16,0,0,1,52.08,49.22l5.32,94.44H76A11,11,0,0,1,65,361.27Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.84,371.58,75.3,283.34a52.15,52.15,0,0,1,52.06-55.42h0a52.16,52.16,0,0,1,52.07,49.22l5.33,94.44Z",
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.18,386.77H77.85a1.54,1.54,0,0,1-1.43-1.36l-2-13.83h8.11l-2,13.83A1.52,1.52,0,0,1,79.18,386.77Z",
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.18,386.77H77.85a1.54,1.54,0,0,1-1.43-1.36l-2-13.83h8.11l-2,13.83A1.52,1.52,0,0,1,79.18,386.77Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.83,386.77h-1.21a1.45,1.45,0,0,1-1.29-1.36l-1.78-13.83h7.35l-1.78,13.83A1.45,1.45,0,0,1,209.83,386.77Z",
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.83,386.77h-1.21a1.45,1.45,0,0,1-1.29-1.36l-1.78-13.83h7.35l-1.78,13.83A1.45,1.45,0,0,1,209.83,386.77Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.22,386.77H171a1.45,1.45,0,0,1-1.29-1.36l-1.79-13.83h7.36l-1.78,13.83A1.46,1.46,0,0,1,172.22,386.77Z",
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.22,386.77H171a1.45,1.45,0,0,1-1.29-1.36l-1.79-13.83h7.36l-1.78,13.83A1.46,1.46,0,0,1,172.22,386.77Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.68,386.77h-1.33a1.53,1.53,0,0,1-1.43-1.36l-2-13.83h8.11l-2,13.83A1.52,1.52,0,0,1,119.68,386.77Z",
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.68,386.77h-1.33a1.53,1.53,0,0,1-1.43-1.36l-2-13.83h8.11l-2,13.83A1.52,1.52,0,0,1,119.68,386.77Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.71,338.25h35.56L201.62,304l.5-7.36h0l.24-3.39a22.84,22.84,0,0,1,.34-2.65c0-.19.09-.39.13-.58a2.09,2.09,0,0,1,.11-.43,20.48,20.48,0,0,1,5.41-9.2,17.45,17.45,0,0,1,11.1-5H186c-.37,0-.73,0-1.1,0a17.4,17.4,0,0,0-12.12,5,20.48,20.48,0,0,0-5.41,9.2,2.09,2.09,0,0,0-.11.43,22.43,22.43,0,0,0-.47,3.23l-.23,3.39h0Z",
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.71,338.25h35.56L201.62,304l.5-7.36h0l.24-3.39a22.84,22.84,0,0,1,.34-2.65c0-.19.09-.39.13-.58a2.09,2.09,0,0,1,.11-.43,20.48,20.48,0,0,1,5.41-9.2,17.45,17.45,0,0,1,11.1-5H186c-.37,0-.73,0-1.1,0a17.4,17.4,0,0,0-12.12,5,20.48,20.48,0,0,0-5.41,9.2,2.09,2.09,0,0,0-.11.43,22.43,22.43,0,0,0-.47,3.23l-.23,3.39h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135.53,320H121.24c-3.47,0-6.28,2.2-6.28,4.91v8.45c0,2.71,2.81,4.91,6.28,4.91h14.29Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 125.52,
    y: 319.99,
    width: 73.74,
    height: 18.27,
    rx: 5.42,
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5,295.57a20.26,20.26,0,0,0,16.81,20L66,364.26c.32,4.14,3.32,7.32,6.92,7.32h39.23c-3.6,0-6.6-3.18-6.92-7.32l-2-26-1.72-22.71A20.25,20.25,0,0,1,87,304.88c-.19-.36-.36-.73-.52-1.1a19.91,19.91,0,0,1-1.75-8.21,20.19,20.19,0,0,1,.43-4.14c.11-.54.25-1.08.39-1.6a20.72,20.72,0,0,1,3.37-6.6h0a20.33,20.33,0,0,1,7-5.77,20.08,20.08,0,0,1,9-2.14H65.76a20.16,20.16,0,0,0-6,.91,20.21,20.21,0,0,0-10.07,7h0A20.21,20.21,0,0,0,45.5,295.57Z",
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5,295.57a20.26,20.26,0,0,0,16.81,20L66,364.26c.32,4.14,3.32,7.32,6.92,7.32h39.23c-3.6,0-6.6-3.18-6.92-7.32l-2-26-1.72-22.71A20.25,20.25,0,0,1,87,304.88c-.19-.36-.36-.73-.52-1.1a19.91,19.91,0,0,1-1.75-8.21,20.19,20.19,0,0,1,.43-4.14c.11-.54.25-1.08.39-1.6a20.72,20.72,0,0,1,3.37-6.6h0a20.33,20.33,0,0,1,7-5.77,20.08,20.08,0,0,1,9-2.14H65.76a20.16,20.16,0,0,0-6,.91,20.21,20.21,0,0,0-10.07,7h0A20.21,20.21,0,0,0,45.5,295.57Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.72,295.57c0,10,6.59,18.34,15.24,20l3.34,48.73c.29,4.15,3,7.32,6.28,7.32H214.32c3.26,0,6-3.17,6.28-7.32l3.35-48.8c8.47-1.78,14.88-10,14.88-19.89a21.56,21.56,0,0,0-3.38-11.71,19.06,19.06,0,0,0-6.78-6.41,16.84,16.84,0,0,0-8.2-2.14,17.38,17.38,0,0,0-12.12,5,20.53,20.53,0,0,0-5.42,9.2,3,3,0,0,0-.1.43,21.12,21.12,0,0,0-.47,3.23l-.24,3.39h0l-2.85,41.64H124.63l-3.09-45c-.45-6.36-3.54-11.66-7.84-14.17a17.14,17.14,0,0,0-9.51-3.69c-.37,0-.73,0-1.1,0a16.63,16.63,0,0,0-8,2,1.2,1.2,0,0,0-.23.11,19.13,19.13,0,0,0-6.36,5.77h0A21.56,21.56,0,0,0,84.72,295.57Z",
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.35,371.58h88c3.26,0,6-3.17,6.28-7.32l3.35-48.8c8.47-1.78,14.88-10,14.88-19.89a21.56,21.56,0,0,0-3.38-11.71,19.06,19.06,0,0,0-6.78-6.41,16.84,16.84,0,0,0-8.2-2.14,17.38,17.38,0,0,0-12.12,5,20.53,20.53,0,0,0-5.42,9.2,3,3,0,0,0-.1.43,21.12,21.12,0,0,0-.47,3.23l-.24,3.39h0l-2.85,41.64H124.63Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.13 388.79 161.66 391.15 169.32 371.1 160.79 368.74 153.13 388.79",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.48,388.49a4.45,4.45,0,0,0-2.73-1.66L154,385.12a.81.81,0,0,0-1,.54l-2.71,8a1.75,1.75,0,0,0,1.07,2.24l.06,0c3.24,1.28,5.43.84,10.49,1.82,3.13.6,9.68,2.68,14.06,2.5s4.37-4.51,2.53-4.83C172,394.39,167,390.47,165.48,388.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "169.32 371.11 165.37 381.45 156.84 379.07 160.78 368.74 169.32 371.11"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M140.85,295s51.36-.28,49.76,16.92c-1.08,11.62-6.66,23.83-11,35.62-6.31,17.09-11.78,32-11.78,32l-11.7-4.05s10.51-49.42,17.59-54.48H130.29c-14.37,0-20.58-15.78-6.59-34.18C132.25,286.86,140.85,295,140.85,295Z",
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.85,295s51.36-.28,49.76,16.92c.79,10.69-22.79,67.6-22.79,67.6l-11.7-4.05s10.51-49.42,17.59-54.48H130.29c-14.37,0-20.58-15.78-6.59-34.18C132.25,286.86,140.85,295,140.85,295Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.07,263.77c-6.32,5.77-18.73-7.89-20.73-9.51-4.28-3.5-16.86-15.24-16.2-19.32,2-12,21.68,5,27.37,16.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.76,227.66c-3.17.67-6.6-.47-8.83,1.88s-3.16,5.65-3.48,8.87a59,59,0,0,0,.7,13.46q1,8.13,2.09,16.25a48.32,48.32,0,0,1-.51,13.37v0a2.15,2.15,0,0,0,1.22,2.33s24.59.84,31.74.57c3.8-.14,1.19-10.14,2.36-16,.26-1.3,2.8-6.64,3.18-8,1.76-6.45.59-10.89-1-17.37-1.19-4.71-1.68-11.5-4.08-12C140.83,230.13,130.58,225.78,121.76,227.66Z",
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.76,227.66c-3.17.67-6.6-.47-8.83,1.88s-3.16,5.65-3.48,8.87a59,59,0,0,0,.7,13.46q1,8.13,2.09,16.25a48.32,48.32,0,0,1-.51,13.37v0a2.15,2.15,0,0,0,1.22,2.33s24.59.84,31.74.57c3.8-.14,1.19-10.14,2.36-16,.26-1.3,2.8-6.64,3.18-8,1.76-6.45.59-10.89-1-17.37-1.19-4.71-1.68-11.5-4.08-12C140.83,230.13,130.58,225.78,121.76,227.66Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.25,232.28c-.33-.5-9-7.78-10.55.63-2.19,11.71,2.34,23.23,2.34,23.23s1,12.67,4.72,13.94,7.18,1.58,8.42-.59a12.87,12.87,0,0,0,1.24-5.41S124,241,118.25,232.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.24,211.59c.89,5.39,1.64,15.24-2.21,18.71,0,0,9.41,4.93,15.59,13.53a8.15,8.15,0,0,0,2.86-9.1,7.94,7.94,0,0,0-4-4.78c-3.65-2-3.3-5.78-2.3-9.32Z",
    style: {
      fill: "#e8bfbf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.47,220.74l3.51,1.35a11.51,11.51,0,0,0,4.72.76h0a7.52,7.52,0,0,0,0,3.34,6.74,6.74,0,0,1-7-2.24A11.59,11.59,0,0,1,125.47,220.74Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.6 371.55 222.16 371.55 212.15 347.58 205.67 358.58 212.6 371.55",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.37,369.28l-11.21-2.55a.79.79,0,0,0-.94.51l-3.13,8.62a1.72,1.72,0,0,0,1.18,2.13l0,0c3.93.82,5.86,1,10.79,2.13,3,.69,10.72,2.71,14.91,3.66s5.29-3.15,3.62-3.93c-7.48-3.46-11.53-6.77-13.7-9.59A2.7,2.7,0,0,0,221.37,369.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "212.15 347.58 216.41 357.79 207.81 362.59 205.67 358.59 212.15 347.58"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M111.54,283.93l-1,3.26c-.13.25.16.51.58.53l37,1.12c.34,0,.61-.14.64-.35l.43-3.28c0-.22-.26-.42-.61-.44l-36.4-1.1A.67.67,0,0,0,111.54,283.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.82,310.68c-12.17,5.19-25.37,10.37-32.55,10.37-14.38,0-27.15-10.38-13.54-34,8.56,0,23.43.24,23.43.24s28-8,48.38-5.64A23,23,0,0,1,203.43,300c5.16,26,13.11,54.12,13.11,54.12l-10.23,7S190.36,327.59,181.18,301C176.32,302.53,167.39,306.6,157.82,310.68Z",
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.43,300a23,23,0,0,0-19.89-18.37c-20.34-2.32-48.38,5.64-48.38,5.64s-14.87-.27-23.43-.24c-13.83,23.52-.84,34,13.54,34,7.18,0,20.38-5.18,32.55-10.37,9.57-4.08,18.5-8.15,23.36-9.71,9.18,26.62,25.13,60.16,25.13,60.16l10.23-7S208.59,326,203.43,300Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.61,312a95.68,95.68,0,0,1-1.5,9.95c-.05-.11-.09-.21-.13-.32s0-.05,0-.08a1.79,1.79,0,0,0-.13-.32c-2.72-6.76-5.38-13.69-7.63-20.22l.07,0h0C187.11,303.48,191.08,307,190.61,312Z",
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.61,312a95.68,95.68,0,0,1-1.5,9.95c-.05-.11-.09-.21-.13-.32s0-.05,0-.08a1.79,1.79,0,0,0-.13-.32c-2.72-6.76-5.38-13.69-7.63-20.22l.07,0h0C187.11,303.48,191.08,307,190.61,312Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.68,206.41c3,8.45,4.1,12.09,9.72,15.26,8.47,4.78,18.17-.78,17.75-10-.38-8.25-5.23-20.69-14.63-21.69a12.23,12.23,0,0,0-12.84,16.39Z",
    style: {
      fill: "#e8bfbf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.87,205.31c.21.73.74,1.16,1.2,1s.64-.8.46-1.51-.73-1.16-1.2-1S132.67,204.61,132.87,205.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.72,202.83c.21.74.74,1.17,1.2,1s.64-.8.46-1.51-.74-1.16-1.19-1S140.52,202.14,140.72,202.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,201.43l1.54-1S142.05,202,141,201.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.91,204.43a19.51,19.51,0,0,0,3.78,3.76,3.1,3.1,0,0,1-2.37,1.15Z",
    style: {
      fill: "#ed847e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.16,212a25.41,25.41,0,0,1,1.39,4.71,6.53,6.53,0,0,1-5.55,6.8,6.27,6.27,0,0,0,7.23-3.27A8.53,8.53,0,0,1,111,224.9a9.07,9.07,0,0,0,7.25-3.49c-.47,1.22-1,2.43-1.42,3.65a15.67,15.67,0,0,0,5.65-5.92c.53-1,.93-2.3.23-3.18s-1.81-.82-2.83-.84-2.25-.26-2.62-1.21.31-1.9,1.05-2.55,1.63-1.25,1.9-2.2a4.14,4.14,0,0,0-.14-2.06q-.69-2.76-1.36-5.53a5.74,5.74,0,0,0-.69-1.85c-2-3-4.23,1.4-5,2.89A13.11,13.11,0,0,0,112.16,212Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.09,214.69a7.06,7.06,0,0,0,4.64,2.69c2.45.3,3.31-2,2.33-4.09-.89-1.92-3.23-4.37-5.54-3.72S115.71,212.85,117.09,214.69Z",
    style: {
      fill: "#e8bfbf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,199.27a.47.47,0,0,1-.37.38c-2,.38-3.16,2.79-3.16,2.81a.46.46,0,0,1-.6.23.45.45,0,0,1-.22-.59c.09-.09,1.33-2.86,3.81-3.34a.46.46,0,0,1,.52.36A.26.26,0,0,1,133,199.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.34,197.27a.49.49,0,0,0-.38.1c-.11.12-.48.33-.27.44,1.22.62,2.91,1.64,4.21,1.43.22,0,.74-.23.63-.39a.64.64,0,0,0-.6-.19c-1,.14-2.41-.83-3.37-1.33A.9.9,0,0,0,138.34,197.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.14,203.9l1.55-1S134.2,204.49,133.14,203.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,186.28c-3.41-.62-3.85-.85-7.31-.63A17.26,17.26,0,0,0,116,189a15.8,15.8,0,0,0-5.29,8.46,24.45,24.45,0,0,0-.26,10.08,6.56,6.56,0,0,0,1.94,4.22,25.65,25.65,0,0,1,.91-5.31,8.64,8.64,0,0,1,3-4.41,4.69,4.69,0,0,0,1.6-1.42,5.83,5.83,0,0,0,.36-1.82,5.62,5.62,0,0,1,2.34-3.43,19.19,19.19,0,0,1,3.77-1.94c4.21-1.81,8.8-2.85,12.68-5.29A18.37,18.37,0,0,0,133,186.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.55,199.66a6.62,6.62,0,0,0,3.57,2.23c1.66.38,5.81.28,6.06-.15s-1.23-5.09-2.91-5.37a11.34,11.34,0,0,0,4.06,2.52,13.26,13.26,0,0,0,5.2,0c.88-.2-1.09-3.84-2.52-4.88,4.31.9,8.87,1.93,12,5s4.48,7.93,4.32,12.46a6.2,6.2,0,0,0,2.31-4.92,18.37,18.37,0,0,1-1.27,14.27c4.58-3.76,6.29-10.33,5.09-16.13s-5-10.85-9.61-14.56c-4-3.17-8.76-5.54-13.83-5.66C121.37,184.27,109.05,191.83,115.55,199.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.94,226.4c0-.33.08-.77.12-1.23a4.28,4.28,0,0,0-3.48-4.56h0a1.77,1.77,0,0,1-1.36-1.16c-.77-2.24-1.07-2.92-1.81-5.12-2-.49-4.41.26-6.5.48a18.22,18.22,0,0,0-.12,7.64,3.43,3.43,0,0,0,.64,1.56,27.27,27.27,0,0,0,6.24,3.84C116.47,228.4,119,226.57,120.94,226.4Z",
    style: {
      fill: "#e8bfbf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.88,227.9s-5.51,35.55.17,41c3.33,3.18,6.21,1.42,8-.57a7.1,7.1,0,0,0,1.74-5.48l-3.87-36.42S117.12,224.18,114.88,227.9Z",
    style: {
      fill: "#e8bfbf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.08,260a15.1,15.1,0,0,0,4.66-7.48,14.59,14.59,0,0,0,.2-3.1c-.05-6.44-1.87-18.25-1.87-18.25l-5.23-1.73s-1.63,9-2,13.92c-.07,1-.18,2.11-.3,3.32-.23,2.2-.51,4.62-.76,6.63Z",
    style: {
      fill: "#e8bfbf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.07,263.77c1.61-1.47,1.88-3.25,2.71-7,.79-3.58-.1-8-.84-7.33a.72.72,0,0,0-.2.31c-1.27,3-6.21.37-7.61-1.13a10.21,10.21,0,0,1-1.58-1.92,1.61,1.61,0,0,1,0-1.82c-1.52-.63-2.74,5.35-2,6.82l.38,1.11a15.47,15.47,0,0,0,2.74,4.94l2.75,3.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.7,230.19l-.62-9.14a37.14,37.14,0,0,0,5,1.95c2.54.87,6-.66,5.2,1a69.5,69.5,0,0,1-4.26,7.16Z",
    style: {
      fill: "#e8bfbf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.08,221.05,175,211.9l5.12,3.13c1.41,3.06,1.24,9,1.24,9S174.24,224.31,171.08,221.05Z",
    style: {
      fill: "#e8bfbf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.31,214c.13.65.6,1.11,1,1s.65-.69.51-1.34-.6-1.11-1-1S137.17,213.39,137.31,214Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.63,338.25l-3.09-45c-.45-6.36-3.54-11.66-7.84-14.17a17.14,17.14,0,0,0-9.51-3.69c-.37,0-.73,0-1.1,0a16.63,16.63,0,0,0-8,2,1.2,1.2,0,0,0-.23.11,19.13,19.13,0,0,0-6.36,5.77h0a21.56,21.56,0,0,0-3.8,12.34c0,10,6.59,18.34,15.24,20l3.34,48.73c.29,4.15,3,7.32,6.28,7.32h16.77Z",
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.63,338.25l-3.09-45c-.45-6.36-3.54-11.66-7.84-14.17a17.14,17.14,0,0,0-9.51-3.69c-.37,0-.73,0-1.1,0a16.63,16.63,0,0,0-8,2,1.2,1.2,0,0,0-.23.11,19.13,19.13,0,0,0-6.36,5.77h0a21.56,21.56,0,0,0-3.8,12.34c0,10,6.59,18.34,15.24,20l3.34,48.73c.29,4.15,3,7.32,6.28,7.32h16.77Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-43"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 244.16,
    cy: 411.89,
    rx: 33.54,
    ry: 8.58,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 244.16,
    cy: 410.46,
    rx: 33.54,
    ry: 7.15,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.93 410.45 241.39 410.45 234.99 341.43 253.33 341.43 246.93 410.45",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.33,341.43c0,2-4.1,3.64-9.17,3.64s-9.17-1.63-9.17-3.64,4.11-3.64,9.17-3.64S253.33,339.42,253.33,341.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.33,341.43c0,2-4.1,3.64-9.17,3.64s-9.17-1.63-9.17-3.64,4.11-3.64,9.17-3.64S253.33,339.42,253.33,341.43Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,342.51a3.1,3.1,0,0,1,1.07-2.16c7.75,7.8,56.92,13.81,116.42,13.81s108.67-6,116.43-13.81a3.1,3.1,0,0,1,1.07,2.16c0,8.81-52.61,16-117.5,16S132,351.32,132,342.51Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.11,344.5c7.75-7.8,56.92-13.8,116.42-13.8s108.67,6,116.43,13.8c-7.76,7.8-56.93,13.81-116.43,13.81S140.86,352.3,133.11,344.5Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,342.2c0-8.82,52.6-16,117.49-16s117.5,7.14,117.5,16a3.06,3.06,0,0,1-1.07,2.15c-7.76-7.8-56.93-13.8-116.43-13.8s-108.67,6-116.42,13.8A3.06,3.06,0,0,1,132,342.2Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.85,334.43l-49.16-.93a1,1,0,0,1-.89-1.12h0a1,1,0,0,1,.94-1.08l49.16.93a1,1,0,0,1,.9,1.12h0A1,1,0,0,1,294.85,334.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.85,334.43l-49.16-.93a1,1,0,0,1-.89-1.12h0a1,1,0,0,1,.94-1.08l49.16.93a1,1,0,0,1,.9,1.12h0A1,1,0,0,1,294.85,334.43Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.72,330.84l-23.5,3.55a1,1,0,0,1-1-.95h0a1.1,1.1,0,0,1,.81-1.23l23.5-3.55a1,1,0,0,1,1,.95h0A1.1,1.1,0,0,1,318.72,330.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.51 328.66 268.83 328.66 245.74 331.3 293.56 332.2 318.51 328.66",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.51 328.66 268.83 328.66 245.74 331.3 293.56 332.2 318.51 328.66",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.72,330.84l-23.5,3.55a1,1,0,0,1-1-.95h0a1.1,1.1,0,0,1,.81-1.23l23.5-3.55a1,1,0,0,1,1,.95h0A1.1,1.1,0,0,1,318.72,330.84Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.56,332.2l-45.84-.86a3.56,3.56,0,0,1-3.11-3.56l-1.38-27.68c-.1-1.93,1.15-3.48,2.76-3.45l45.84.87a3.54,3.54,0,0,1,3.11,3.56l1.39,27.67C296.42,330.68,295.18,332.23,293.56,332.2Z",
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.56,332.2l-45.84-.86a3.56,3.56,0,0,1-3.11-3.56l-1.38-27.68c-.1-1.93,1.15-3.48,2.76-3.45l45.84.87a3.54,3.54,0,0,1,3.11,3.56l1.39,27.67C296.42,330.68,295.18,332.23,293.56,332.2Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.22,332.06l-45.84-.87a3.56,3.56,0,0,1-3.12-3.56L241.88,300c-.1-1.93,1.15-3.48,2.77-3.45l45.83.86a3.56,3.56,0,0,1,3.12,3.56L295,328.61C295.08,330.54,293.83,332.09,292.22,332.06Z",
    style: {
      fill: "#3C008F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.22,332.06l-45.84-.87a3.56,3.56,0,0,1-3.12-3.56L241.88,300c-.1-1.93,1.15-3.48,2.77-3.45l45.83.86a3.56,3.56,0,0,1,3.12,3.56L295,328.61C295.08,330.54,293.83,332.09,292.22,332.06Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.36,313.83a5.41,5.41,0,0,0,5.29,4.86,4.39,4.39,0,0,0,4.44-4.86A5.43,5.43,0,0,0,266.8,309,4.39,4.39,0,0,0,262.36,313.83Z",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultingRafiki);
export default __webpack_public_path__ + "static/media/Consulting-rafiki.4466668e9040ba0b33f9472d0cea1658.svg";
export { ForwardRef as ReactComponent };